import { EnumModel } from 'app/shared/objects/EnumModel';
import {GridConfiguration, GridRequest} from '../../shared/helpers/dx-grid-helper';
export class PushMessage {

  }




export class PushMessageRequestModel extends GridRequest {
  past = false;
  searchTime = new Date();
}

export class PushMessageGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        caption: 'Push Messages',
        cellTemplate: 'imgAndName'
      },
      {
        dataField: 'date',
        dataType: 'date',
        format: 'dd/MM/yyyy',
        caption: 'DATE'
      },

      
      {
        caption: 'MESSAGE',
        dataField: 'message'
      },
      {
        caption: 'SCREEN LINK',
        dataField: 'screenCode'
      },
    ];

    this.customSearch = [
      {
        fieldName: 'title',
        value: ''
      }
    ];
    this.paging = {
      enabled: true,
      pageIndex: 0,
      pageSize: 10
    };
    this.pager.showPageSizeSelector = false;
    // this.pager = {
    //   showPageSizeSelector: false,
    //   showNavigationButtons: true,
    //   allowedPageSizes: [5],
    //   pageSize: 5,
    //   showInfo: ''
    // };

    this.selection = {
      mode: 'none',
      allowSelectAll: false
    };
    this.sorting = { mode: 'none' };
  }


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}


export class PushMessageListItemResponseModel {
  public Id: number;
  public Title: string;
  public Message: string;
  public Date: Date;
  public ScreenCode: string;
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-messages-database/push-message-database.model.ts